module.exports = __webpack_public_path__ + "img/jingyin.35c81fe6.png";